'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prefix = function prefix(key) {
  return 'private-drag-drop-key-do-not-use-store-' + key;
};

var storeKey = exports.storeKey = prefix('store');
var droppableIdKey = exports.droppableIdKey = prefix('droppable-id');


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/context-keys.js
// module id = 2993
// module chunks = 0